<template>
  <div>
    <qx-card title="客户" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="$route.query.type"
      :busiId="$route.query.id"
      busiCode="100000"
    />
  </div>
</template>

<script>
import {
  userDetail, // 获取详情
} from 'api/system';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  data () {
    return {
      loading: false,
      detailData: {
        account: {
          label: '账号信息',
          tableData: {
            title: [
              {
                prop: 'loginAcct',
                label: '员工账号',
              },
              {
                prop: 'lockFlagName',
                label: '账号状态',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        worker: {
          label: '员工信息',
          tableData: {
            title: [
              {
                prop: 'linkman',
                label: '员工姓名',
              },
              {
                prop: 'identification',
                label: '身份证号',
              },
              {
                prop: 'employeeNumber',
                label: '员工工号',
              },
              {
                prop: 'staffPosition',
                label: '员工职位',
              },
              {
                prop: 'joinedDate',
                label: '员工入职时间',
              },
              {
                prop: 'employeeAttributesName',
                label: '员工属性',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/system/jurisdiction/worker/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await userDetail({
        userId: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.detailData.account.tableData.data = detailRes;
        this.detailData.worker.tableData.data = detailRes;
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
